import React from 'react';
import { CheckCircle } from 'lucide-react';

const ProfileSection = () => {
  return (
    <section className="profile-section section-container">
      <div className="section-header">
        <h2 className="section-title">Esta agencia no es para todos</h2>
      </div>

      <div className="profile-content">
        <p className="profile-intro">The Keeper Lab es para porteros que:</p>

        <div className="profile-criteria">
          <div className="criteria-item">
            <CheckCircle className="criteria-icon" />
            <p>Quieren competir en el máximo nivel</p>
          </div>
          <div className="criteria-item">
            <CheckCircle className="criteria-icon" />
            <p>Buscan estructura profesional real</p>
          </div>
          <div className="criteria-item">
            <CheckCircle className="criteria-icon" />
            <p>Entienden que el desarrollo mental es decisivo</p>
          </div>
          <div className="criteria-item">
            <CheckCircle className="criteria-icon" />
            <p>No se conforman con ser uno más</p>
          </div>
        </div>

        <div className="profile-decision">
          <p>Si buscas comodidad, no somos tu agencia.</p>
          <p className="highlight">Si buscas trascender, sí.</p>
        </div>
      </div>
    </section>
  );
};

export default ProfileSection;
